<template>
  <div>
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>

    <div>
      <div style="margin-bottom: 10px">
        <el-button type="danger" plain size="mini" @click="cleartextShow('短信日志')">明文查看
        </el-button>

      </div>
      <el-table :data="tableData" border>
        <el-table-column v-for="(headerItem) in tableHeader" :key="headerItem.prop" :prop="headerItem.prop"
                         :width="headerItem.width" :label="headerItem.label">
          <template v-slot="scope">
            <template v-if="headerItem.type === 1">{{ scope.row[headerItem.prop] | formatTime }}</template>
            <template v-else-if="headerItem.type === 9">
              <template v-if="phoneNumShow">{{ scope.row[headerItem.prop] }}</template>
              <template v-else>{{ scope.row[headerItem.prop] | phNoFilter }}</template>
            </template>
            <template v-else-if="headerItem.type === 2">
              <el-tag>{{ scope.row[headerItem.prop] }}</el-tag>
            </template>
            <template v-else>{{ scope.row[headerItem.prop] }}</template>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination layout="sizes, prev, pager, next" :total="totalCount" :page-sizes="pageSizes"
                       :page-size.sync="curPageSize" :pager-count="5"
                       :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {getListSms} from "@/api/log-api";
import {mixin_clearPhoneNumShow, mixin_page_table} from "@/utils/mixin";
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";

export default {
  name: "SmsLog",
  components: {ClearPhoneNoDialog},
  mixins: [mixin_page_table, mixin_clearPhoneNumShow],
  data() {
    return {
      tableHeader: [
        {prop: 'id', label: '序号', width: 100, type: 0},
        {prop: 'tel', label: '手机号码', width: 180, type: 9},
        {prop: 'type', label: '短信类型', width: 180, type: 2},
        {prop: 'content', label: '短信内容', width: '', type: 0},
        {prop: 'time', label: '时间', width: 200, type: 1},

      ],
    }
  },
  filters: {
    formatTime(time) {
      const date = new Date(time);
      const year = date.getFullYear().toString().slice(-2);
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      const hour = date.getHours().toString().padStart(2, '0');
      const minute = date.getMinutes().toString().padStart(2, '0');
      const second = date.getSeconds().toString().padStart(2, '0');
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
  },
  mounted() {
    this.refreshTableData()
  },
  methods: {
    refreshTableData() {
      this.tableData = []
      let pageIndex = this.curPageIndex
      let pageSize = this.curPageSize
      getListSms(pageIndex, pageSize).then(({data}) => {
        console.log("getListSms", data)
        if (data.code === 200) {
          this.tableData = data.data.data
          this.totalCount = data.data.totals

        } else {
          this.$message.error(data.msg)
          this.showServerErrMsg(data.msg)
        }
      }).catch(err => {
        console.log(err)
        this.showNetErrMsg()
      })
    },
  }
}
</script>


<style scoped lang="less">
.el-table {
  //max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>
